import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GeneralForm from '../../components/generalForm';
import { useBusinessProfiles, usePaymentMethod, usePaymentMethodCreate, usePaymentMethodEdit } from './apiHooks';
import utils from '../../utils/utils';
import CustomSelect from '../../components/customFields/customSelect';

function AdminPaymentMethodForm({ intl, match, history, action }) {
  const [formPaymentMethod, setFormPaymentMethod] = useState({
    maxLimit: '',
    className: 'PaymentMethodInvoice',
  });

  const {
    isLoading: loading,
    isError,
    error,
  } = usePaymentMethod({
    paymentMethodId: match.params.paymentMethodId,
    onSuccess: (paymentMethod) =>
      setFormPaymentMethod({
        ...paymentMethod,
        maxLimit: paymentMethod.maxLimit.toString(),
        businessProfileId: paymentMethod.businessProfile?.id,
      }),
  });

  const { businessProfiles } = useBusinessProfiles({});

  const {
    editPaymentMethod,
    isLoading: editLoading,
    isError: isEditError,
    error: editError,
  } = usePaymentMethodEdit(() =>
    history.push({
      pathname: '/admin/paymentMethods',
    })
  );

  const {
    createPaymentMethod,
    isLoading: createLoading,
    isError: isCreateError,
    error: createError,
  } = usePaymentMethodCreate(() =>
    history.push({
      pathname: '/admin/paymentMethods',
    })
  );

  const businessProfileOptions = businessProfiles
    ? businessProfiles.map((businessProfile) => {
        return {
          value: businessProfile.id,
          label: `${businessProfile.companyName} - ${businessProfile.registryCode}`,
        };
      })
    : [];

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      maxLimit: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.method.form.field.limit.label' }),
      },
      isPrimary: {
        type: 'boolean',
        title: intl.formatMessage({ id: 'payment.method.form.field.is.primary.label' }),
      },
      businessProfileId: {
        type: 'string',
        title: intl.formatMessage({ id: 'payment.method.form.field.business.profile.id.label' }),
        options: businessProfileOptions,
      },
    },
  };

  const uiSchema = {
    businessProfileId: {
      'ui:field': 'customSelect',
    },
  };

  const onFormSubmit = () => {
    try {
      if (action === 'create') {
        createPaymentMethod({ paymentMethod: formPaymentMethod });
      } else {
        editPaymentMethod({ paymentMethod: formPaymentMethod });
      }
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  const formFields = {
    customSelect: CustomSelect,
  };

  const buttonCopy = 'payment.method.edit.form.submit';

  return (
    <div className="m-b-6">
      <GeneralForm
        onChange={(event) => setFormPaymentMethod(event.formData)}
        onSubmit={onFormSubmit}
        formSchema={formSchema}
        formUiSchema={uiSchema}
        formFields={formFields}
        formData={formPaymentMethod}
        buttonCopy={buttonCopy}
        errorMessage={
          isError || isEditError || isCreateError
            ? utils.getErrorMessageFromResponse(error || editError || createError, true)
            : null
        }
        loading={loading || editLoading || createLoading}
        hideImageUpload={true}
      />
    </div>
  );
}

AdminPaymentMethodForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
};

AdminPaymentMethodForm.defaultProps = {
  onSuccess: () => {},
  action: 'create',
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminPaymentMethodForm));
